module.exports = __webpack_public_path__ + "static/questions-85ae05e589e31916f4df62c1c5a90ec0.png";